import React from "react";
import weatherapp from '../asset/weatherapp.png';
import webmusic from '../asset/web_music.png'; 
import login from '../asset/login.png';
import kanan from '../asset/kanan.png';
import kosongan from '../asset/kosongan.png';
import kiri from '../asset/kiri.png';




const Projects = () => {
    return (
        <section id="projects" className="py-10 bg-rosegold">
    <h2 className="text-4xl bg-rosegold text-cream font-bold mb-5 pt-1" style={{ fontFamily: 'Kavoon' }}>My Projects</h2>
    <div className="container mx-auto text-center">
  <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mt-5">
    <div className="bg-cream p-4 rounded">
      <img src={weatherapp} alt="kumpulan projek" className="w-full h-48 object-cover mb-4 rounded" />
    </div>
    <div className="bg-rosegold p-4 rounded">
      <img src={kosongan} alt="kumpulan projek" className="w-48 h-48 object-cover mb-4 rounded" />
    </div>
    <div className="bg-cream p-4 rounded">
      <img src={webmusic} alt="kumpulan projek" className="w-full h-48 object-cover mb-4 rounded" />
    </div>
    <div>
      <img src={kiri} alt="kiri" className="w-full rounded p-7" />
    </div>
    <div className="bg-cream p-4 m-5 rounded"> 
      <img src={login} alt="kumpulan projek" className="w-full h-full object-cover rounded" /> 
    </div>
    <div>
      <img src={kanan} alt="kanan" className="w-full rounded p-7"  />
    </div>
  </div>   
</div>

</section>

           
    )
}

export default Projects